/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState } from "react";
// import { Listbox, Transition } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import styles from "../styles/selector.module.css";
import axios from "axios";

const optionss = {
  Declined: {
    title: "Declined",
    color: "text-[#D40017]",
    bgColor: "bg-[#D40017]",
  },
  Pending: {
    title: "Pending",
    color: "text-[#D8AA6B]",
    bgColor: "bg-[#D8AA6B]",
  },
  Approved: {
    title: "Approved",
    color: "text-[#007530]",
    bgColor: "bg-[#007530]",
  },
};

const options = [
  {
    title: "Declined",
    value: "0",
    color: "text-[#D40017]",
    bgColor: "bg-[#D40017]",
  },
  {
    title: "Pending",
    value: "1",
    color: "text-[#D8AA6B]",
    bgColor: "bg-[#D8AA6B]",
  },
  {
    title: "Approved",
    value: "3",
    color: "text-[#007530]",
    bgColor: "bg-[#007530]",
  },
];


function ApplicationStatus({ status, applicationId, disabled }) {
  const [applicationStatus, setApplicationStatus] = useState(status);
  const handleChange = async (event) => {
    await axios
      .get(
        `${"https://api.camp-coding.site"}/careers/jobapplication/update/${applicationId}/${event.target.value}`
      )
      .then(setApplicationStatus(event.target.value));
  };

  return (
    <div
      className={`${styles.selectBox} ${optionss[applicationStatus].bgColor} min-w-[50px]`}
    >
      <select
        disabled={disabled}
        value={applicationStatus}
        onChange={(e) => {
          handleChange(e);
        }}
        className={`${optionss[applicationStatus].bgColor} pl-2 outline-none cursor-pointer font-sans rounded py-[3px]  border-none text-[white] w-[100%] `}
      >
        {options.map((option, index) => (
          <option
            // selected={option.title === applicationStatus}
            value={option.title}
            key={index}
            className={`${option.color}  outline-[0px] hover:bg-[white] bg-[white] py-[4px] rounded`}
          >
            {option.title.charAt(0).toLocaleUpperCase() + option.title.slice(1)}
          </option>
        ))}
      </select>
    </div>
  );
}

export default ApplicationStatus;
